import { useCallback, type ReactElement } from 'react'
import { useTranslation } from '@front/model'
import { useRouter, useNavigate } from '@tanstack/react-router'
import { TButton } from './button'

export type ButtonBackProps = {
  /**
   * If provided, the button will use this function to navigate
   * If not provided, the button will use `goBackBehavior` to navigate
   */
  handleGoBack?: () => void
  /**
   * If 'history', will use the history API to navigate back
   * If 'relative', will use the relative path to navigate back
   * goBackBehavior will be ignored if handleGoBack is provided
   * @default 'relative'
   */
  goBackBehavior?: 'history' | 'relative'
}

export const ButtonBack = ({ goBackBehavior = 'relative', handleGoBack }: ButtonBackProps): ReactElement => {
  const { t } = useTranslation()
  const router = useRouter()
  const navigate = useNavigate()
  const handleClick = useCallback(() => {
    if (handleGoBack) {
      handleGoBack()
      return
    }
    if (goBackBehavior === 'relative') {
      navigate({ to: '..' })
    } else {
      router.history.back()
    }
  }, [goBackBehavior, handleGoBack, navigate])

  return (
    <TButton buttonType='icon-full' icon='chevron_left' variant='gray' onClick={handleClick}>
      {t('Back')}
    </TButton>
  )
}
